import MESSAGES from '@/utils/messages'

export default (_, inject) => {
    inject('messages', MESSAGES)
}